import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      ...(process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID && {
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
      }),
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [`${process.env.REACT_APP_APP_BASE_URL}/`],
          redirectSignOut: [`${process.env.REACT_APP_APP_BASE_URL}/login`],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
};


Amplify.configure(amplifyConfig);

export default amplifyConfig;
